export default __webpack_public_path__ + "static/media/TheWitness.64266d6f.png";